import "../SurveyStatsCards.css";

export default function SurveyStatsCards({ invites, responses, unAnswered }) {
  const totalInvites = invites.length;
  const totalResponses = responses.length;
  const totalUnanswered = unAnswered.length;
  const totalContacted = totalResponses + totalUnanswered;

  const responseRate =
    totalInvites > 0 ? Math.round((totalResponses / totalContacted) * 100) : 0;

  const unansweredRate =
    totalInvites > 0 ? Math.round((totalUnanswered / totalInvites) * 100) : 0;

  return (
    <div className="statsGrid">
      <div className="statCard">
        <div className="statLabel">Totalt kontaktade</div>
        <div className="statValue">{totalContacted}</div>
        <div className="statSubtext">inkl. telefonsamtal, sms och e-post</div>
      </div>

      <div className="statCard">
        <div className="statLabel">Besvarade enkäter</div>
        <div className="statValue">{totalResponses}</div>
        <div className="statSubtext">{responseRate}% svar (av kontaktade)</div>
      </div>

      <div className="statCard">
        <div className="statLabel">Skapade inbjudningar</div>
        <div className="statValue">{totalInvites}</div>
        <div className="statSubtext">totalt (sms eller e-post)</div>
      </div>

      <div className="statCard">
        <div className="statLabel">Obesvarade inbjudningar</div>
        <div className="statValue">{totalUnanswered}</div>
        <div className="statSubtext">{unansweredRate}% obesvarade (av inbjudningar)</div>
      </div>
    </div>
  );
}